<h1 mat-dialog-title class="dialog__title">{{ 'dataManagement.directory.dialog.addEditFolder.moveTitle' | transloco }}</h1>

<mat-dialog-content>
  <div class="dialog-body" [class.fixed-height]="searchable">
    @if (searchable) {
      <div class="search-bar">
        <mat-form-field class="search-field" appearance="outline" subscriptSizing="dynamic">
          <mat-icon matPrefix>search</mat-icon>
          <input
            matInput
            type="text"
            autocomplete="off"
            [formControl]="searchControl"
            [placeholder]="'dataManagement.directory.dialog.selectLocation.searchPlaceholder' | transloco" />
          @if (searchControl.value) {
            <button matSuffix mat-icon-button type="button" (click)="searchControl.setValue('')">
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>
      </div>
    }

    <div class="tree-area">
      <mat-card class="treeview-container">
        @if (!hasSelectableFolder) {
          <p class="no-results">{{ 'dataManagement.directory.dialog.selectLocation.noWritableFolder' | transloco }}</p>
        } @else {
          @for (root of treeRoots(); track root) {
            <app-directory-tree
              [rootFolder]="root"
              [includeRecyclingBin]="false"
              [expandedFolderIds]="expandedFolderIds()"
              [disabledFolderIds]="disabledFolderIds"
              (folderActivated)="setSelectedFolder($event)">
            </app-directory-tree>
          } @empty {
            <p class="no-results">{{ 'dataManagement.directory.dialog.selectLocation.noResults' | transloco }}</p>
          }
        }
      </mat-card>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button (click)="discardChanges()" type="button">
    {{ 'common.buttons.cancel' | transloco }}
  </button>
  <button [disabled]="isUnreachable() || !selectedFolder" mat-raised-button color="primary" (click)="acceptChanges()" type="submit">
    {{ 'common.buttons.select' | transloco }}
  </button>
</mat-dialog-actions>
